// AuthorsRights.jsx
import '../../input.css'
import { useTranslation } from 'react-i18next'
import Policy from './Policy'

const authorsRightsPt = (
  <div>
    <p>
      Esta Política de Direitos Autorais e Propriedade Intelectual descreve as
      regras de uso dos ativos do Benjamin e da Lean it 101.
    </p>
    <br />
    <div>
      <strong>Resumo rápido</strong>
      <ul>
        <li>Benjamin, marcas e software são propriedade da Lean it 101.</li>
        <li>Você recebe uma licença limitada para uso interno.</li>
        <li>Não é permitido copiar, revender ou criar obras derivadas.</li>
      </ul>
    </div>
    <br />
    <div>
      <strong>1. Titularidade</strong>
    </div>
    <br />
    <div>
      Todos os direitos sobre o Benjamin, código-fonte, algoritmos, prompts,
      design, marcas, logos e conteúdos são da Lean it 101 ou de seus
      licenciantes, protegidos pela legislação brasileira e tratados
      internacionais.
    </div>
    <br />
    <div>
      <strong>2. Licença</strong>
    </div>
    <br />
    <div>
      Concedemos ao Cliente uma licença limitada, não exclusiva e
      intransferível para acessar e utilizar o Benjamin conforme o plano
      contratado, apenas para uso interno.
    </div>
    <br />
    <div>
      <strong>3. Restrições</strong>
    </div>
    <br />
    <div>
      É proibido, sem autorização prévia: copiar, reproduzir, redistribuir,
      revender, sublicenciar, realizar engenharia reversa ou usar a marca Lean
      it 101 em materiais públicos.
    </div>
    <br />
    <div>
      <strong>4. Conteúdo do Cliente</strong>
    </div>
    <br />
    <div>
      O Conteúdo do Cliente permanece de sua propriedade. Você garante ter
      direitos para enviar esses dados e concede licença para uso dentro da
      prestação dos Serviços.
    </div>
    <br />
    <div>
      <strong>5. Violações</strong>
    </div>
    <br />
    <div>
      Se houver uso indevido, podemos suspender o acesso e adotar medidas
      legais. Reporte violações para legal@leanit101.com.
    </div>
    <br />
    <div>Última atualização: 27 de dezembro de 2025</div>
  </div>
)

const authorsRightsEn = (
  <div>
    <p>
      This Copyright and Intellectual Property Policy describes how Benjamin
      and Lean it 101 assets may be used.
    </p>
    <br />
    <div>
      <strong>Quick summary</strong>
      <ul>
        <li>Benjamin, trademarks, and software are owned by Lean it 101.</li>
        <li>You receive a limited license for internal use.</li>
        <li>You may not copy, resell, or create derivatives.</li>
      </ul>
    </div>
    <br />
    <div>
      <strong>1. Ownership</strong>
    </div>
    <br />
    <div>
      All rights in Benjamin, source code, algorithms, prompts, design,
      trademarks, logos, and content belong to Lean it 101 or its licensors and
      are protected by law.
    </div>
    <br />
    <div>
      <strong>2. License</strong>
    </div>
    <br />
    <div>
      We grant the Customer a limited, non-exclusive, non-transferable license
      to access and use Benjamin under the contracted plan, for internal use
      only.
    </div>
    <br />
    <div>
      <strong>3. Restrictions</strong>
    </div>
    <br />
    <div>
      You may not, without prior authorization, copy, reproduce, redistribute,
      resell, sublicense, reverse engineer, or use Lean it 101 branding in
      public materials.
    </div>
    <br />
    <div>
      <strong>4. Customer Content</strong>
    </div>
    <br />
    <div>
      Customer Content remains yours. You represent you have rights to submit
      it and grant us a license to use it to provide the Services.
    </div>
    <br />
    <div>
      <strong>5. Violations</strong>
    </div>
    <br />
    <div>
      We may suspend access and pursue legal action for violations. Report
      issues to legal@leanit101.com.
    </div>
    <br />
    <div>Last updated: December 27, 2025</div>
  </div>
)

const AuthorsRights = () => {
  const { i18n } = useTranslation()
  const isPt = i18n.language && i18n.language.toLowerCase().startsWith('pt')
  return (
    <div className="">
      <Policy
        name={isPt ? 'Direitos autorais' : 'Copyright'}
        text={isPt ? authorsRightsPt : authorsRightsEn}
      />
    </div>
  )
}

export default AuthorsRights
